import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import * as S from './styles';
import { useDeviceConfig } from 'console/shared/contexts/device/config';
import { CustomControlProvider } from 'console/shared/components/panels/custom-controls/custom-controls-card/provider';
import { useZ3KCustomControlsConfig } from 'console/shared/contexts/heating-device/lib/hooks/entities/z3k';
import { removeNulls } from 'utils';
import { CustomControlsCard } from 'console/shared/components/panels/custom-controls/custom-controls-card';
import { HeatingDeviceConfigProvider } from 'console/shared/contexts/heating-device/config';
export const SocketModelView = memo(function SocketModelView() {
    const { device_id, z3k_config } = useDeviceConfig();
    const custom_control_config = useZ3KCustomControlsConfig(device_id, z3k_config, true);
    return (_jsx(HeatingDeviceConfigProvider, { children: _jsx(S.ModelView, { children: removeNulls(custom_control_config).map((config) => (_jsx(CustomControlProvider, { custom_control_config: config, children: _jsx(CustomControlsCard, { hide_go_to_settings_button: true, iconFontSize: "5em" }) }, config.id))) }) }));
});
